import React from 'react';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    icon?: string;
    rightElement?: React.ReactNode;
    leftElement?: React.ReactNode;
    onBack?: () => void;
    className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, icon, rightElement, leftElement, onBack, className = '' }) => {
    return (
        <div className={`w-full flex items-center justify-between mb-6 ${className}`}>
            <div className="flex items-center gap-4 flex-1 min-w-0">
                {onBack && (
                    <button
                        onClick={onBack}
                        className="p-2 min-w-[40px] min-h-[40px] rounded-full bg-surface-2/50 hover:bg-primary hover:text-white transition-all border border-white/10 flex items-center justify-center flex-shrink-0"
                    >
                        <span className="material-symbols-outlined text-sm">arrow_back_ios_new</span>
                    </button>
                )}
                {leftElement && (
                    <div className="flex-shrink-0">
                        {leftElement}
                    </div>
                )}

                <div className="flex items-center gap-3 flex-1 min-w-0">
                    {icon && (
                        <span className="material-symbols-outlined text-3xl text-primary shrink-0">
                            {icon}
                        </span>
                    )}
                    <div className="flex-1 min-w-0">
                        <h1 className="text-2xl sm:text-3xl font-black text-primary tracking-tight leading-tight break-words">
                            {title}
                        </h1>
                        {subtitle && (
                            <p className="text-sm font-medium text-text-secondary mt-1 break-words">
                                {subtitle}
                            </p>
                        )}
                    </div>
                </div>
            </div>

            {rightElement && (
                <div className="flex-shrink-0 pl-2">
                    {rightElement}
                </div>
            )}
        </div>
    );
};
